if (!customElements.get('product-navigation')) {
  class productNavigation extends HTMLElement {
    constructor() {
      super();
      this.container = document.querySelector('.product-nav__container');
      this.header = document.querySelector('.shopify-section--header');
      this.themeName = this.getAttribute('data-theme-name');
      this.originalOffsetTop = this.container.offsetTop; // Store the original offset
      this.isFixed = false; // Flag to track fixed state

      // Add a placeholder div to prevent content jump
      this.placeholder = document.createElement('div');
      this.placeholder.style.display = 'none';
      this.container.parentNode.insertBefore(this.placeholder, this.container);

      // Filter and add click listeners for smooth scrolling
      this.querySelectorAll('a[data-anchor-id]').forEach((anchor) => {
        const targetId = anchor.getAttribute('data-anchor-id');

        if (!targetId) return;

        const targetElement = document.querySelector(`[data-section-id="${targetId}"]`);

        if (!targetElement) {
          const parentDiv = anchor.closest('div'); // Adjust this selector to match your actual structure
          if (parentDiv) {
            parentDiv.style.display = 'none';
          }
          return;
        }

        anchor.addEventListener('click', (event) => {
          event.preventDefault();

          const offset = 114; // Adjust for fixed header
          const targetPosition =
            targetElement.getBoundingClientRect().top + window.scrollY - offset;
          const scrollOffset = targetPosition - 64;

          window.scrollTo({
            top: scrollOffset,
            behavior: 'smooth',
          });
        });
      });

      // Update observer options for better section detection
      const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -70% 0px', // Adjust margins to better detect active section
        threshold: [0, 0.25, 0.5, 0.75, 1],
      };

      const observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        observerOptions
      );

      // Observe all sections with an id
      document.querySelectorAll('[data-section-id]').forEach((section) => {
        observer.observe(section);
      });

      window.addEventListener('scroll', this.handleScroll.bind(this));
      window.addEventListener('resize', this.updateOffset.bind(this));
    }

    getOffset() {
      // Return offset based on screen width
      return window.innerWidth <= 1024 ? 65 : 114;
    }

    updateOffset() {
      // Update the original offset when resizing the screen
      this.originalOffsetTop = this.container.offsetTop;
    }
    handleScroll() {
      const headerHeight = this.header.offsetHeight;
      const scrollTriggerPoint = this.originalOffsetTop - headerHeight;

      if (!this.isFixed && window.scrollY >= scrollTriggerPoint) {
        // Store the original height before fixing
        const navHeight = this.container.offsetHeight;

        // Show and size the placeholder
        this.placeholder.style.display = 'block';
        this.placeholder.style.height = `${navHeight}px`;

        this.container.classList.add('fixed');
        this.container.style.top = `${headerHeight}px`;
        this.container.style.zIndex = '20';
        this.container.style.width = '100%';
        this.isFixed = true;
      } else if (this.isFixed && window.scrollY < scrollTriggerPoint) {
        // Hide the placeholder
        this.placeholder.style.display = 'none';

        this.container.classList.remove('fixed');
        this.container.style.top = '';
        this.container.style.zIndex = '';
        this.container.style.width = '';
        this.isFixed = false;
      }
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        const targetId = entry.target.getAttribute('data-section-id');
        const correspondingLink = this.querySelector(`a[data-anchor-id="${targetId}"]`);

        if (entry.isIntersecting) {
          // Remove active state from all links
          this.querySelectorAll('a[data-anchor-id]').forEach((link) => {
            if (this.themeName === 'liftmaster') {
              link.classList.remove('text-lm-secondary', 'border-b-lm-secondary');
            } else {
              link.classList.remove('text-primary-orange', 'border-b-primary-orange');
            }
          });

          // Add active state to current section's link
          if (correspondingLink) {
            if (this.themeName === 'liftmaster') {
              correspondingLink.classList.add('text-lm-secondary', 'border-b-lm-secondary');
            } else {
              correspondingLink.classList.add('text-primary-orange', 'border-b-primary-orange');
            }
          }
        }
      });
    }
  }

  window.productNavigation = productNavigation;

  customElements.define('product-navigation', productNavigation);
}
